import { useContext, useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import ajaxProduct from "../../util/remote/ajaxProduct";
import ajaxStores from "../../util/remote/ajaxStores";
import Select from "react-select";
import Loader from "../../Components/Common/Loader";
import SystemModal from "../../Components/Common/SystemModal";
import AuthContext from "../../Context/AuthContext";
const UpdateStoreMovement = (props) => {
  const { userId } = useContext(AuthContext);
  const movement = props.data;
  const [loading, setLoading] = useState(false);
  // Form fields
  const [oldStoreId, setOldStoreId] = useState(movement.old_store_id);
  const [newStoreId, setNewStoreId] = useState(movement.new_store_id);
  const [productId, setProductId] = useState(movement.product_id);
  const [quantity, setQuantity] = useState(movement.quantity);
  const [reference, setReference] = useState(movement.reference || "");
  const [transter_date, setTranster_date] = useState(
    movement.transfer_date || "",
  );
  const [notes, setNotes] = useState(movement.notes || "");
  // Dropdown data
  const [stores, setStores] = useState([]);
  const [products, setProducts] = useState([]);
  // Fetch stores and products for dropdowns
  useEffect(() => {
    const loadStores = async () => {
      const res = await ajaxStores.fetchStores();
      if (res.status === "OK") setStores(res.details);
    };
    const loadProducts = async () => {
      const res = await ajaxProduct.fetchProductList();
      if (res.status === "OK") setProducts(res.details);
    };
    loadStores();
    loadProducts();
  }, []);
  const handleSubmit = async (e, controls) => {
    e.preventDefault();
    if (!oldStoreId || !newStoreId || !productId || quantity <= 0) {
      toast.error(
        "Please complete all required fields (old store, new store, product, quantity)",
      );
      return;
    }
    if (oldStoreId === newStoreId) {
      toast.error("Old store and new store cannot be the same");
      return;
    }
    setLoading(true);
    const payload = {
      movement_id: movement.movement_id,
      old_store_id: oldStoreId,
      new_store_id: newStoreId,
      product_id: productId,
      quantity: parseFloat(quantity),
      reference: reference,
      transter_date: transter_date,
      notes: notes,
      user_id: userId,
    };
    const response = await ajaxProduct.updateStoreMovement(payload);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      controls.close();
      props.function(); // refresh parent list
    } else {
      toast.error(response.message);
    }
  };
  const RenderFooter = (controls) => {
    if (loading) {
      return <Loader />;
    } else {
      return (
        <>
          <button
            className="btn ripple btn-dark"
            type="button"
            onClick={controls.close}
          >
            Close
          </button>
          <button
            type="button"
            disabled={loading}
            className="btn ripple btn-success"
            onClick={(e) => handleSubmit(e, controls)}
          >
            Save changes
          </button>
        </>
      );
    }
  };
  return (
    <SystemModal
      title="Update Store Transfer Movement"
      id="modal-update-store-movement"
      size="lg"
      footer={RenderFooter}
    >
      <div className="row">
        <div className="mb-4 col-md-6">
          <label>
            From Store <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            onChange={(e) => setOldStoreId(e.id)}
            getOptionLabel={(option) => option.storeName}
            getOptionValue={(option) => option.id}
            isSearchable
            options={stores}
            value={stores.find((s) => s.id === oldStoreId) || ""}
          />
        </div>
        <div className="mb-4 col-md-6">
          <label>
            To Store <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            onChange={(e) => setNewStoreId(e.id)}
            getOptionLabel={(option) => option.storeName}
            getOptionValue={(option) => option.id}
            isSearchable
            options={stores}
            value={stores.find((s) => s.id === newStoreId) || ""}
          />
        </div>
        <div className="mb-4 col-md-6">
          <label>
            Product <span style={{ color: "red" }}>*</span>
          </label>
          <Select
            onChange={(e) => setProductId(e.id)}
            getOptionLabel={(option) => option.product_name}
            getOptionValue={(option) => option.id}
            isSearchable
            options={products}
            value={products.find((p) => p.id === productId) || ""}
          />
        </div>
        <div className="mb-4 col-md-6">
          <label>
            Quantity <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="number"
            step="any"
            className="form-control"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
        </div>
        <div className="mb-4 col-md-12">
          <label>Reference</label>
          <input
            type="text"
            className="form-control"
            value={reference}
            onChange={(e) => setReference(e.target.value)}
          />
        </div>
        <div className="mb-4 col-md-12">
          <label>Notes</label>
          <textarea
            className="form-control"
            rows="3"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
      </div>
    </SystemModal>
  );
};
export default UpdateStoreMovement;
